import { OnDestroy } from '@angular/core';
import { SubSink } from 'subsink';
import { BsAppLaunchFormService } from '../services/bs-app-launch-form.service';
import { BasespaceFormControl, getTogglerValues } from './bs-app-launch-form-control';

export abstract class BsAppLaunchFormControlBaseComponent<T extends BasespaceFormControl<any>> implements OnDestroy {
  abstract formControl: T;
  
  protected subs = new SubSink();

  constructor(protected bsAppLaunchFormService: BsAppLaunchFormService) {}

  onFocus(): void {
    this.formControl.trackValueForFormUpdates();
  }

  checkAndFireFormUpdate(): void {
    if (this.formControl.shouldTriggerFormUpdates()) {
      this.bsAppLaunchFormService.formUpdateTrigger$.next({ controlId: this.formControl.id });
    }
  }

  toggle(): void {
    if (this.formControl['togglers']) {
      const values = getTogglerValues(this.formControl, this.bsAppLaunchFormService.togglerCascadingEnabled);
      this.formControl['togglers'].forEach((toggler: any) => {
        this.bsAppLaunchFormService.toggle(toggler.toggleOnValue, toggler.toggleFields, values);
      });
    }
  }

  destroy(): void {
    this.formControl.destroy();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}

